import React, { useEffect, useMemo } from 'react';
import useRedux from 'infrastructure/js/hooks/useRedux';
import LotsGrid from './LotsGrid/lotsGrid';
import { jsxActions as lotsGridActions } from '../../../actions/LotsPage/lotsGridActions';
import { jsxActions as lotsPageActions } from '../../../actions/LotsPage/lotsPageActions';
import { jsxActions as fetchEntitiesActions } from '../../../actions/FetchEntities/fetchEntitiesActions';
import { jsxActions as editStatusDialogActions } from '../../../actions/Dialogs/EditStatusDialog/editStatusDialogActions';
import useNavBarUpdate from 'infrastructure/js/hooks/useNavBarUpdate';
import { navigationStates } from '../../../enums/navigationStates';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Header, {headerItemsLabels} from '../../Common/Header/header';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import {gridsNames} from '../../../enums/gridsNames';
import {List} from 'immutable';
import {PL_DialogWrapper} from 'infrastructure/js/components/Dialog/dialog';
import EditStatusDialog from '../../Dialogs/EditStatusDialog/editStatusDialog';
import {FetchEntitiesFilters} from '../../../enums/fetchEntitiesFilters';
import {enumTypes, getEnumValue} from '../../../utils/enumHelper';
import {isLotAccessible, isLotInCoCTemplateCreation, isLotInPreparation} from '../../../utils/assetHelper';

import './lotsPage.scss';

const getState = (state) => {
  let grid = state.grid?.get(gridsNames.PREDEFINED_LIST_LOTS) || null;

  return {
    sHasRows: grid?.get('rows')?.size > 0 || false,
    sSelectedRowsData: grid?.get('selectedRowsData') || List(),
    sEditStatusDialogData: state.dialogs.get('editStatusDialog'),
  };
}

const allActions = {
  lotsGridActions,
  lotsPageActions,
  fetchEntitiesActions,
  editStatusDialogActions,
};

const isLotsStatusEditable = (lots = []) => {
  return lots.every(item => isLotAccessible(item.status));
}

export default function LotsPage() {
  const labels = useMemo(() => createLabelHelper('mat.lots.page.'), []);
  const updateNavBar = useNavBarUpdate();
  const { state, actions } = useRedux(allActions, getState);
  const {sHasRows = false, sSelectedRowsData, sEditStatusDialogData } = state;

  useEffect(() => {
    updateNavBar(navigationStates.LOTS, labels.get('title'));
  }, [updateNavBar, labels]);


  const getHeaderItems = () => {
    return {
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.lotsPageActions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        {
          id: 'refresh',
          label: '',
          icon: 'pl pl-refresh',
          action: actions.lotsPageActions.reload,
          tooltip: headerItemsLabels.REFRESH,
        },
        ...(PermissionManager.isCoCEnabled() ? [
          {
            id: 'automateCoC',
            label: headerItemsLabels.AUTOMATE_COC,
            icon: 'pl pl-coc',
            disabled: !(sSelectedRowsData?.size === 1 &&
              (isLotInPreparation(sSelectedRowsData?.get(0)?.status) || isLotInCoCTemplateCreation(sSelectedRowsData?.get(0)?.status))),
            action: actions.lotsPageActions.onEditStatus,
            actionData: {
              boEntityFilter: [FetchEntitiesFilters.ACTIVE],
              entitiesTypes: [getEnumValue(enumTypes.OBJECT_TYPE)('LOT')],
              preselectedAssets: sSelectedRowsData,
              isAutomateMode: true,
            },
          },
          {
            id: 'editStatus',
            label: headerItemsLabels.EDIT_STATUS,
            icon: 'pl pl-edit-icon',
            disabled: sSelectedRowsData?.size > 0 && !isLotsStatusEditable(sSelectedRowsData?.toJS()),
            action: actions.lotsPageActions.onEditStatus,
            actionData: {
              boEntityFilter: [FetchEntitiesFilters.ACTIVE],
              entitiesTypes: [getEnumValue(enumTypes.OBJECT_TYPE)('LOT')],
              preselectedAssets: sSelectedRowsData,
              isAutomateMode: false,
            },
          },
        ] : []),
      ]
    }
  }


  return (
    <div className="lots-page">
      <Header {...getHeaderItems()}/>
      <LotsGrid actions={{ ...actions.lotsGridActions, ...actions.fetchEntitiesActions }}
                exportCoCAutomationTemplate={actions.lotsPageActions.exportCoCAutomationTemplate}
      />

      <PL_DialogWrapper dialogComponent={EditStatusDialog}
                        show={sEditStatusDialogData.get('show')}
                        actions={actions.editStatusDialogActions}
                        sData={sEditStatusDialogData}
                        reloadParentComponent={actions.lotsPageActions.reload} />
    </div>
  );
}
